const API_URL = "https://cheese-api-updated.vercel.app"

export default API_URL